import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: [
      '"proxima-nova"',
    ].join(','),
  },
});
